import Tooltip from '@mui/material/Tooltip'
import { createLink } from '@tanstack/react-router'
import type { ComponentProps, ReactNode } from 'react'
import { Button } from './generic.tsx'
import { Icon, type IconName } from './Icon.tsx'

type IconButtonProps = {
	icon: IconName
	/** Plain-text translated label used for `aria-label`, testing, and as the default tooltip. Pass `null` to explicitly opt out. */
	label: string | null
	/** Rich tooltip content. Overrides `label` in the tooltip when provided. Requires `label` for accessibility and testing. */
	tooltip?: ReactNode
} & ComponentProps<typeof Button>

export const IconButton = ({ icon, label, tooltip, ...props }: IconButtonProps) => {
	const sanitizedLabel = label?.replaceAll(/<[^>]*>/g, '')
	return (
		<Tooltip title={tooltip ?? sanitizedLabel} disableInteractive enterNextDelay={100} describeChild>
			{/* Wrap in <span> to support tooltips on disabled button https://mui.com/material-ui/react-tooltip/#disabled-elements */}
			<span>
				<Button variant='text' color='secondary' aria-label={sanitizedLabel} startIcon={<Icon name={icon} />} {...props} />
			</span>
		</Tooltip>
	)
}

export const LinkIconButton = createLink(IconButton)
